export const config = {
  title: "Mojicas Painting and General Construction | San Fernando, CA",
  meta: {
    description:
      "Mojicas Painting and General Construction specializes in expert painting and general contracting services in San Fernando, CA. Residential and commercial projects with precision and quality craftsmanship.",
    keywords: [
      "Mojicas Painting and General Construction",
      "Painting Services San Fernando",
      "General Contractor Los Angeles",
      "Residential Painting CA",
      "Commercial Construction",
      "Interior Painting",
      "Exterior Painting",
      "Home Remodeling",
      "Construction Services California"
    ],
    author: "Mojicas Painting and General Construction",
    canonicalUrl: "https://www.mojicasgeneralconstruction.com/",
  },
  sections: {
    header: {
      businessName: "Mojicas Painting and General Construction",
    },
    sectionB: {
      heroTitle: "Crafting Your Dream Spaces",
      heroSubtitle: "Precision in Every Detail - Expert Painting & General Construction Services",
      learnAboutText: "Request a Quote",
      phoneNumber: "8183225114",
      phoneLabel: "(818) 322-5114",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1562259949-e8e7689d7828?q=80&w=2074&auto=format&fit=crop",
      cardData: [
        {
          title: "Professional Painting",
          description:
            "Expert interior and exterior painting services with high-quality finishes for residential and commercial properties.",
        },
        {
          title: "General Construction",
          description:
            "Complete construction services including remodeling, renovations, and new construction projects.",
        },
        {
          title: "Quality Craftsmanship",
          description:
            "Meticulous attention to detail and commitment to excellence in every project we undertake.",
        },
      ],
      description:
        "Mojicas Painting and General Construction is here to serve all your construction needs. We specialize in expert construction services, delivering high-quality results in painting and general contracting for both residential and commercial projects.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Professional painting and construction services with commitment to quality, professionalism, and efficient project management.",
      cards: [
        {
          title: "Interior & Exterior Painting",
          description:
            "Professional painting services for homes and businesses, using premium materials and expert techniques for beautiful, long-lasting results.",
          imageSrc: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Professional Painting Services",
        },
        {
          title: "Remodeling & Renovations",
          description:
            "Transform your space with our expert remodeling services, from kitchens and bathrooms to complete home renovations.",
          imageSrc: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Home Remodeling Services",
        },
        {
          title: "General Construction",
          description:
            "Comprehensive construction services including remodeling, renovations, repairs, and new construction for residential and commercial clients.",
          imageSrc: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "General Construction Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Drywall Installation & Repair",
        "Carpentry Services",
        "Flooring Installation",
        "Cabinet Installation",
        "Stucco & Masonry Work",
      ],
    },
    sectionD: {
      aboutTitle: "About Mojicas Painting and General Construction",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2161507261/photo/a-professional-house-painters-painting-an-apartment.jpg?s=612x612&w=0&k=20&c=23syAvxJUCVG_vug99OBXq5ew2-R5H95FCgXgbJlxhU=",
        alt: "Mojicas Construction Team",
      },
      aboutText: [
        "Mojicas Painting and General Construction specializes in expert construction services in San Fernando and throughout the Los Angeles area. We pride ourselves on delivering high-quality results in painting and general contracting for both residential and commercial projects, ensuring every detail meets your expectations.",
        "Our commitment to excellence means we approach every project with professionalism, skill, and attention to detail. From small painting jobs to complete construction projects, our experienced team delivers exceptional workmanship and reliable service. We build lasting relationships with our clients through quality work and efficient project management.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Mojicas Painting and General Construction",
      businessName: "Mojicas Painting and General Construction",
      contact: {
        phone: "8183225114",
        phoneLabel: "(818) 322-5114",
        email: "info@mojicasgeneralconstruction.com",
        website: "https://www.mojicasgeneralconstruction.com/",
        address: "843 San Fernando, CA 91340",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "843 San Fernando, CA 91340",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3299.8!2d-118.4396!3d34.2818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c295e8e8e8e8e8%3A0x8e8e8e8e8e8e8e8e!2s843%20San%20Fernando%2C%20CA%2091340!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;